import { jsx, jsxs } from 'react/jsx-runtime';
import { createContext, useContext, useState, useCallback, useEffect, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import styled, { css, useTheme } from 'styled-components';
import { Backdrop } from '../../components/Backdrop/Backdrop.esm.js';
import { Box } from '../../components/Layout/Layout.esm.js';
import { useDisableExternalInputs } from '../../hooks/useDisableExternalInputs/useDisableExternalInputs.esm.js';
import { useHideMobileKeyboard } from '../../hooks/useHideMobileKeyboard/useHideMobileKeyboard.esm.js';
import { useViewportSize } from '../../hooks/useViewportSize/useViewportSize.esm.js';
import { fadeOutAnimation } from '../../presets/cssAnimations/cssAnimations.esm.js';
import { TransitionPhase } from '../../helpers/transitionGroup.esm.js';

function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n  height: 100%;\n  border: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " dialog {\n      ",
        "\n    }\n    &.",
        " {\n      animation: ",
        " 0.2s ease-in-out forwards;\n    }\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  border: none;\n  padding: 0;\n  overflow: hidden;\n  flex-grow: 1;\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
/* istanbul ignore next */ var DialogContext = /*#__PURE__*/ createContext({
    isDialogOpen: false,
    openDialog: function() {},
    closeDialog: function() {},
    openIframeDialog: function() {}
});
function useDialogContext() {
    return useContext(DialogContext);
}
var StyledIframe = styled.iframe(_templateObject());
var AnimatedDialogWrapper = styled(CSSTransition)(_templateObject2(), function(param) {
    var dialog = param.dialog;
    var _dialog_transitionPhases, _dialog_transitionPhases1, _dialog_transitionPhases2, _dialog_transitionPhases3, _dialog_transitionPhases4, _dialog_transitionPhases5, _dialog_transitionPhases6, _dialog_transitionPhases7, _dialog_transitionPhases8;
    return css(_templateObject1(), TransitionPhase.Appear, (_dialog_transitionPhases = dialog.transitionPhases) === null || _dialog_transitionPhases === void 0 ? void 0 : _dialog_transitionPhases.appear, TransitionPhase.AppearActive, (_dialog_transitionPhases1 = dialog.transitionPhases) === null || _dialog_transitionPhases1 === void 0 ? void 0 : _dialog_transitionPhases1.appearActive, TransitionPhase.AppearDone, (_dialog_transitionPhases2 = dialog.transitionPhases) === null || _dialog_transitionPhases2 === void 0 ? void 0 : _dialog_transitionPhases2.appearDone, TransitionPhase.Enter, (_dialog_transitionPhases3 = dialog.transitionPhases) === null || _dialog_transitionPhases3 === void 0 ? void 0 : _dialog_transitionPhases3.enter, TransitionPhase.EnterActive, (_dialog_transitionPhases4 = dialog.transitionPhases) === null || _dialog_transitionPhases4 === void 0 ? void 0 : _dialog_transitionPhases4.enterActive, TransitionPhase.EnterDone, (_dialog_transitionPhases5 = dialog.transitionPhases) === null || _dialog_transitionPhases5 === void 0 ? void 0 : _dialog_transitionPhases5.enterDone, TransitionPhase.Exit, (_dialog_transitionPhases6 = dialog.transitionPhases) === null || _dialog_transitionPhases6 === void 0 ? void 0 : _dialog_transitionPhases6.exit, TransitionPhase.ExitActive, (_dialog_transitionPhases7 = dialog.transitionPhases) === null || _dialog_transitionPhases7 === void 0 ? void 0 : _dialog_transitionPhases7.exitActive, TransitionPhase.ExitDone, (_dialog_transitionPhases8 = dialog.transitionPhases) === null || _dialog_transitionPhases8 === void 0 ? void 0 : _dialog_transitionPhases8.exitDone, TransitionPhase.ExitActive, fadeOutAnimation());
});
var DialogContainer = styled(Box).attrs({
    as: "dialog"
})(_templateObject3(), function(param) {
    var dialog = param.dialog;
    return dialog.dialogStyle;
});
var DialogProvider = function(param) {
    var children = param.children, _param_closeOnUrlChange = param.closeOnUrlChange, closeOnUrlChange = _param_closeOnUrlChange === void 0 ? true : _param_closeOnUrlChange;
    var theme = useTheme();
    var dialogStyles = theme.dialog;
    var isMobileViewport = useViewportSize().isMobileViewport;
    var _useState = useState({
        children: null
    }), _useState1 = _sliced_to_array(_useState, 2), _useState_ = _useState1[0], dialogChildren = _useState_.children, onClose = _useState_.onClose, setDialog = _useState1[1], dialogOptions = _object_without_properties(_useState[0], [
        "children",
        "onClose"
    ]);
    var _useState2 = _sliced_to_array(useState(false), 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var close = useCallback(function() {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        setIsOpen(false);
    }, [
        onClose
    ]);
    var openInternalDialog = useCallback(function(dialog, options) {
        setDialog(_object_spread({
            children: dialog
        }, options));
        setIsOpen(true);
        if (options.historyHash != null && options.historyHash.length > 0) {
            window.location.hash = options.historyHash;
        }
    }, []);
    useEffect(function() {
        var closeOnKeyDown = function(e) {
            if (e.key === "Escape") {
                close();
            }
        };
        window.addEventListener("keydown", closeOnKeyDown);
        return function() {
            window.removeEventListener("keydown", closeOnKeyDown);
        };
    }, [
        close
    ]);
    var _useState3 = _sliced_to_array(useState(isOpen), 2), shouldHideMobileKeyboard = _useState3[0], setShouldHide = _useState3[1];
    var containerRef = useDisableExternalInputs(isOpen && Boolean(dialogOptions.disableInputsWhileDialogOpen));
    useHideMobileKeyboard(shouldHideMobileKeyboard);
    useEffect(function() {
        var timeout = setTimeout(function() {
            setShouldHide(false);
        }, 300);
        return function() {
            clearTimeout(timeout);
        };
    });
    var openDialog = useCallback(function(dialog) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        openInternalDialog(dialog, options);
    }, [
        openInternalDialog
    ]);
    var openIframeDialog = useCallback(function(url, options) {
        var _options_role;
        openInternalDialog(/*#__PURE__*/ jsx(StyledIframe, {
            role: (_options_role = options.role) !== null && _options_role !== void 0 ? _options_role : "document",
            src: url
        }), options);
    }, [
        openInternalDialog
    ]);
    var handleDialogClick = useCallback(function(e) {
        e.stopPropagation();
    }, []);
    useEffect(function() {
        if (!isOpen) {
            window.location.hash = "";
        }
    }, [
        isOpen
    ]);
    useEffect(function() {
        if (closeOnUrlChange) {
            window.addEventListener("popstate", close);
        }
        return function() {
            window.removeEventListener("popstate", close);
        };
    }, [
        close,
        closeOnUrlChange
    ]);
    var contextValue = useMemo(function() {
        return {
            isDialogOpen: isOpen,
            closeDialog: close,
            openDialog: openDialog,
            openIframeDialog: openIframeDialog
        };
    }, [
        close,
        isOpen,
        openDialog,
        openIframeDialog
    ]);
    var _dialogStyles_fullScreenMargin, _dialogOptions_height, _dialogStyles_fullScreenMargin1, _dialogOptions_width;
    return /*#__PURE__*/ jsxs(DialogContext.Provider, {
        value: contextValue,
        children: [
            children,
            /*#__PURE__*/ jsx(AnimatedDialogWrapper, {
                dialog: dialogStyles,
                in: isOpen,
                mountOnEnter: true,
                onExited: function() {
                    return setDialog({
                        children: null,
                        width: 0
                    });
                },
                timeout: 300,
                unmountOnExit: true,
                children: /*#__PURE__*/ jsx(Backdrop, {
                    onClick: dialogOptions.preventBackdropClose ? undefined : close,
                    children: /*#__PURE__*/ jsx(DialogContainer, _object_spread_props(_object_spread({
                        "aria-modal": "true",
                        dialog: dialogStyles,
                        onClick: handleDialogClick
                    }, dialogOptions), {
                        height: isMobileViewport && dialogOptions.fullScreenInMobile ? "calc(100vh - ".concat(((_dialogStyles_fullScreenMargin = dialogStyles.fullScreenMargin) !== null && _dialogStyles_fullScreenMargin !== void 0 ? _dialogStyles_fullScreenMargin : 0) * 2, "px)") : (_dialogOptions_height = dialogOptions.height) !== null && _dialogOptions_height !== void 0 ? _dialogOptions_height : "fit-content",
                        // @ts-expect-error -- TS complains about open prop doesn't exist, but it's required in order to show the dialog
                        open: true,
                        ref: containerRef,
                        width: isMobileViewport && dialogOptions.fullScreenInMobile ? "calc(100vw - ".concat(((_dialogStyles_fullScreenMargin1 = dialogStyles.fullScreenMargin) !== null && _dialogStyles_fullScreenMargin1 !== void 0 ? _dialogStyles_fullScreenMargin1 : 0) * 2, "px)") : (_dialogOptions_width = dialogOptions.width) !== null && _dialogOptions_width !== void 0 ? _dialogOptions_width : "fit-content",
                        children: dialogChildren
                    }))
                })
            })
        ]
    });
};

export { DialogContainer, DialogContext, DialogProvider, useDialogContext };
